import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import JobsSection from '../components/JobsSection';
import Footer from '../components/Footer';
import { sideObjOne } from '../components/Sidebar/Data';
import { navObjOne } from '../components/Navbar/Data';
import { jobObjOne } from '../components/JobsSection/Data';
import { footerObjOne } from '../components/Footer/Data';

const Job = () => {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        document.title = "Attochron | Jobs";
    }, []);

	const toggle = () => {
		setIsOpen(!isOpen)
	}

    return (
        <>
            <Sidebar isOpen={isOpen} toggle={toggle} {...sideObjOne}/>
            <Navbar toggle={toggle} {...navObjOne}/>
            <JobsSection {...jobObjOne} />
            <Footer {...footerObjOne}/>
        </>
    )
}

export default Job